import { BrandSymbol, Container, Group, Text } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import type { Plan } from '@melio/subscriptions-api';

type SubscriptionCheckoutSummaryPlanProps = {
  planName: Plan['title'];
};

export const SubscriptionCheckoutSummaryPlan = ({ planName }: SubscriptionCheckoutSummaryPlanProps) => {
  const { formatMessage } = useMelioIntl();

  return (
    <Container alignItems="center" width="full" justifyContent="space-between">
      <Group spacing="s" variant="horizontal" alignItems="center">
        <BrandSymbol type="melio" size="extra-large" />

        <Group spacing="xxxs" variant="vertical">
          <Text textStyle="body2Semi" data-testid="subscription-checkout-plan-title">
            {formatMessage('activities.subscription.plans.summary.description', { planName })}
          </Text>
          <Text color="neutral.darker" textStyle="body4">
            {formatMessage('activities.subscription.checkout.billingCycle.annual.label')}
          </Text>
        </Group>
      </Group>

      <Group spacing="xxxs" variant="vertical" textAlign="end">
        <Text textStyle="body2Semi">$384.00</Text>
        <Text color="neutral.darker" textStyle="body4">
          4 Users at $19/user
        </Text>
      </Group>
    </Container>
  );
};
